export function PickyEaterBanner(props: {
  visible: boolean;
  onSuggestUntried: () => void;
  onDismiss?: () => void;
}) {
  if (!props.visible) return null;
  return (
    <div style={{
      position: 'relative',
      padding: 'var(--space-md) var(--space-lg)',
      background: 'var(--accent-peach-bg)',
      borderRadius: 'var(--radius-lg)',
      borderLeft: '3px solid var(--accent-peach)',
      fontSize: 13,
      color: 'var(--accent-peach-ink)',
      display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12,
    }}>
      <span>Strong week of favorites. Consider one untried recipe — exposure is the active ingredient.</span>
      <button onClick={props.onSuggestUntried} style={{
        marginLeft: 'auto',
        background: 'var(--pink-primary)', color: 'var(--on-primary)',
        border: 'none', padding: '6px 12px', borderRadius: 'var(--radius-md)',
        fontSize: 12, fontWeight: 600, cursor: 'pointer',
      }}>Suggest one untried</button>
      {props.onDismiss && (
        <button
          onClick={props.onDismiss}
          aria-label="Dismiss picky-eater banner"
          onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.opacity = '1'; }}
          onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.opacity = '0.6'; }}
          style={{
            position: 'absolute', top: 4, right: 4,
            width: 24, height: 24, padding: 0,
            background: 'transparent', border: 'none',
            color: 'var(--accent-peach-ink)', fontSize: 16, lineHeight: 1,
            cursor: 'pointer', borderRadius: 'var(--radius-xs)',
            opacity: 0.6,
          }}
        >×</button>
      )}
    </div>
  );
}
